import { Forecast } from './../../../../../shared/sdk/models/Forecast';
import { Image } from './../../../../../shared/sdk/models/Image';
import { SeCommonConfig } from './../SeCommonConfig.class';
import { IBaseSEConfig } from '../base-se-config.interface';
import * as _ from 'lodash';

export class SeWeatherMultidayConfig extends SeCommonConfig implements IBaseSEConfig {
  // settings just for this element
  public usePlayerZip = true;
  public manualZip = '44720';
  public SeType = 'SeWeatherMultiday';
  public modelRef: Forecast;


  public defaultDisplay = {
    fontColor: 'rgba(255,255,255,1)',
    showBackgroundColor: true,
    backgroundColor: 'rgba(0,0,0,.3)',
    showBackgroundImage: true,
    useAutoBackground: true,
    descBackgroundColor: 'rgba(0,0,0,.3)',
    header: {
      show: true,
      showLocation: true,
      showDatetime: true
    },
    current: {
      show: true,
      showCurrentTemp: true,
      showRealFeel: true,
      showHighLow: true
    },
    showMainIcon: true,
    showTextDesc: true,
    extra: {
      show: true,
      showBarometer: true,
      showHumidity: true,
      showWindspeed: true
    },
    forecast: {
      show: true,
      numDays: 6

    }
  };

  public display = this.defaultDisplay;

  constructor(jsonString?: string) {
    super();
    if (jsonString) {
      this.fromJsonString(jsonString);
    }
  }

  // create json from class vars
  toJson() {
    const obj = super.toJson(); // process common base config settings
    obj.usePlayerZip = this.usePlayerZip; // and any custom props
    obj.manualZip = this.manualZip;
    obj.SeType = this.SeType;
    obj.modelRef = this.modelRef;

    obj.files = [];

    obj.display = this.display;

    return obj;
  }

  // parse json to class vars
  fromJson(obj) {
    super.fromJson(obj); // process common base config settings

    this.SeType = _.get(obj, 'SeType', 'SeWeatherMultiday');
    this.modelRef = _.get(obj, 'modelRef', null);
    this.usePlayerZip = _.get(obj, 'usePlayerZip', true);
    this.manualZip = _.get(obj, 'manualZip', '44720');

    // override some props that werer filled in by super call
    this.sizeInBytes = _.get(obj, 'modelRef.FileSize', 0);

    // build display obj
    this.display = {
      fontColor: _.get(obj, 'display.fontColor', 'rgba(255,255,255,1)'),
      showBackgroundColor: _.get(obj, 'display.showBackgroundColor', true),
      backgroundColor: _.get(obj, 'display.backgroundColor', 'rgba(0,0,0,.3)'),
      showBackgroundImage: _.get(obj, 'display.showBackgroundImage', true),
      useAutoBackground: _.get(obj, 'display.useAutoBackground', true),
      descBackgroundColor: _.get(obj, 'display.descBackgroundColor', 'rgba(0, 0, 0, 0.3)'),
      header: {
        show: _.get(obj, 'display.header.show', true),
        showLocation: _.get(obj, 'display.header.showLocation', true),
        showDatetime: _.get(obj, 'display.header.showDatetime', true)
      },
      current: {
        show: _.get(obj, 'display.current.show', true),
        showCurrentTemp: _.get(obj, 'display.current.showCurrentTemp', true),
        showRealFeel: _.get(obj, 'display.current.showRealFeel', true),
        showHighLow: _.get(obj, 'display.current.showHighLow', true)
      },
      showMainIcon: _.get(obj, 'display.showMainIcon', true),
      showTextDesc: _.get(obj, 'display.showTextDesc', true),
      extra: {
        show: _.get(obj, 'display.extra.show', true),
        showBarometer: _.get(obj, 'display.extra.showBarometer', true),
        showHumidity: _.get(obj, 'display.extra.showHumidity', true),
        showWindspeed: _.get(obj, 'display.extra.showWindspeed', true)
      },
      forecast: {
        show: _.get(obj, 'display.forecast.show', true),
        numDays: _.get(obj, 'display.forecast.numDays', 6)

      }
    };

    this.files = [];


  }

  toJsonString() {
    return JSON.stringify(this.toJson());
  }

  fromJsonString(str) {
    this.fromJson(JSON.parse(str));
  }


}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-weather-multiday/se-weather-multiday-config.class.ts